import React, {Component, Fragment} from 'react';
import { observer, inject } from 'mobx-react';
import {Button, Input} from "antd";

import {CloseIcon, DownloadIcon, MagnifierIcon, MapIcon, MenuIcon} from '../../../../common/icons';
import CommonSubeader from '../../SubHeader';

import HereService from '../../../../services/Here';
import constants from '../../../../constants';

import './SubHeader.css';
import moment from "moment";
import {Parser as JSON2CSVParser} from "json2csv";

const API_KEY = constants.HERE_API_KEY;

@inject('tripsStore', 'translationsStore', 'filterStore')
@observer
export default class SubHeader extends Component {
  constructor(props) {
    super(props);
    this.mapservice = new HereService(API_KEY);
    this.state = {
      search: ''
    }
  }

  search = () => {
    this.props.tripsStore.setSearch(this.state.search);
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  onChange = e => {
    this.setState({search: e.target.value});
  };

  downloadTrips = () => {
    const { translationsStore, tripsStore } = this.props;
    const { trips, startDate, endDate } = tripsStore;
    const notAvailablePosition = translationsStore.translate('tripsPanel.export.notAvailablePosition');
    const notAvailableDate = translationsStore.translate('tripsPanel.export.notAvailableDate');


    const selectedTrips = trips.filter(trip => tripsStore.isTripSelected(trip.id));

    if (selectedTrips.length === 0) {
      return;
    }

    const fields = [
      {
        label: translationsStore.translate('tripsPanel.export.columns.startTime'),
        value: row => (row.startAt ? new Date(row.startAt).toLocaleString() : notAvailableDate)
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.endTime'),
        value: row => (row.endAt ? new Date(row.endAt).toLocaleString() : notAvailableDate)
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.startPlace'),
        value: row => row.startPlace
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.endPlace'),
        value: row => row.endPlace
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.distance'),
        value: row => row.distance
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.duration'),
        value: row => moment.duration(row.duration || 0, 'seconds').format('h:mm:ss', { trim: false })
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.rating'),
        value: row => row.rating
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.brakes'),
        value: row => row.brakes || 0
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.accelerations'),
        value: row => row.accelerations || 0
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.overDrives'),
        value: row => row.overDrives || 0
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.dayTime'),
        value: row => row.dayDrivePercentage
      },
      {
        label: translationsStore.translate('tripsPanel.export.columns.nightTime'),
        value: row => 100 - row.dayDrivePercentage
      }
    ];
    const exportFilename = `trips_${moment(startDate).format('YYYYMMDD')}_${moment(endDate).format('YYYYMMDD')}.csv`;

    // determinazione dettagliata indirizzo da posizione
    const detailedPromises = selectedTrips.map(item => {
      const startPos = item.positions.slice(0, 1).pop();
      const startLat = startPos ? startPos.loc[1] : null;
      const startLng = startPos ? startPos.loc[0] : null;
      const endPos = item.positions.slice(-1).pop();
      const endLat = endPos ? endPos.loc[1] : null;
      const endLng = endPos ? endPos.loc[0] : null;

      const itemPromises = [
        startPos ? this.mapservice.reverseGeocode(startLat, startLng, 0, 'retrieveAddresses') : Promise.resolve(notAvailablePosition),
        endPos ? this.mapservice.reverseGeocode(endLat, endLng, 0, 'retrieveAddresses') : Promise.resolve(notAvailablePosition)
      ];

      return new Promise(resolve => {
        Promise.all(itemPromises).then(fulfilled => resolve({ ...item, startPlace: fulfilled[0].label, endPlace: fulfilled[1].label }));
      });
    });

    Promise.all(detailedPromises).then(detailedTrips => {
      try {
        const parser = new JSON2CSVParser({ fields, delimiter: ';', withBOM: true });
        const csv = parser.parse(detailedTrips);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');

        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportFilename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
      }
      });
  };

  render() {
    const { translationsStore, tripsStore, onTabChange, selectedTab } = this.props;


    if(tripsStore.selectedDetailTrip) {
      return (
        <CommonSubeader>
          <div></div>
          <div className="rightButtons">
            <div className="clear">
              <div className="icon" onClick={() => tripsStore.setSelectedDetailTrip(null)}>
                <CloseIcon />
              </div>
              <div className="label">{translationsStore.translate('tripsList.subhead.closeTrip')}</div>
            </div>
          </div>
        </CommonSubeader>
      )
    }

    return (
      <CommonSubeader>
        { tripsStore.selectedTrips.length === 0 ? (
          <div className="ItemsContainer">
            <Button.Group className="LayoutSwitch">
              <Button onClick={() => onTabChange('map')} className={selectedTab === 'map' ? 'active' : ''}><MapIcon /></Button>
              <Button onClick={() => onTabChange('list')} className={selectedTab === 'list' ? 'active' : ''}><MenuIcon /></Button>
            </Button.Group>
            <div className="FullTextSearch">
              <Input
                placeholder={translationsStore.translate('tripsList.subhead.searchPlaceholder')}
                prefix={<MagnifierIcon onClick={this.search} />}
                value={this.state.search}
                onChange={this.onChange}
                onKeyDown={this.keyPress}
              />
            </div>
          </div>
        ) : (
          <Fragment>
            <div></div>
            <div className="rightButtons">
              <div className="download">
                <div className="icon" onClick={() => this.downloadTrips()}>
                  <DownloadIcon />
                </div>
                <div className="label">{translationsStore.translate('tripsList.subhead.export')}</div>
              </div>
              <div className="clear">
                <div className="icon" onClick={() => tripsStore.clearSelection()}>
                  <CloseIcon />
                </div>
                <div className="label">{translationsStore.translate('tripsList.subhead.cancelSelection')}</div>
              </div>
            </div>
          </Fragment>

        )
        }
      </CommonSubeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Trips/SubHeader/SubHeader.js